<section class="relatedPoints" aria-labelledby="relatedPointsHeading">
  <header class="relatedPoints__header">
    <h4 id="relatedPointsHeading">
      {{ 'related_points' | ppTranslate: { value: relatedPoints.length } }}
    </h4>

    <button
      class="relatedPoints__expandButton"
      [class.relatedPoints__expandButton--disabled]="relatedPoints.length === 0"
      [disabled]="relatedPoints.length === 0"
      (click)="toggleExpand()"
      [attr.aria-expanded]="expanded"
      aria-controls="relatedPointsList"
    >
      <span class="relatedPoints__expandText">
        <span class="relatedPoints__expandText--underline">
          {{ (expanded ? 'related_points_collapse' : 'related_points_expand') | ppTranslate }}
        </span>
        <span> ({{ relatedPoints.length }})</span>
      </span>

      <pp-icon
        ppClass="setSize18"
        ppColor="grey-400"
        [ppSVG]="
          expanded
            ? iconMap[EIconPath.ICON_MISC_DOWN_ARROW_18]
            : iconMap[EIconPath.ICON_MISC_RIGHT_ARROW_18]
        "
      />
    </button>
  </header>

  <div id="relatedPointsList" class="relatedPoints__list" role="list">
    <ul class="relatedPoints__list__items">
      @if (expanded) {
        @for (relatedPoint of relatedPoints; track $index) {
          <li>
            <pp-related-point-row
              [ppRelatedPoint]="relatedPoint"
              [ppCanDelete]="canDeleteRelation(relatedPoint)"
              [ppPointId]="ppPointId()"
              [ppWorkspaceId]="ppWorkspaceId()"
              [ppIsNewPoint]="ppIsNewPoint()"
              (ppDeleteRelation)="deleteRelation(relatedPoint)"
            />
          </li>
        }
      }
    </ul>
    @if (addingNewRelation) {
      <li class="relatedPoints__newRelation" role="listitem">
        <pp-new-related-point-row
          [ppPointId]="ppPointId()"
          [ppExcludedPointIds]="excludedPointIds"
          (ppRelationAdded)="addRelationToList($event)"
          (ppCancelled)="cancelNewRelation()"
          [ppAccountId]="ppAccountId()"
          [ppWorkspaceId]="ppWorkspaceId()"
          [ppIsNewPoint]="ppIsNewPoint()"
        />
      </li>
    }
  </div>

  @if (canEditRelationsInCurrentWorkspace) {
    <div class="relatedPoints__addButton">
      <button [disabled]="addingNewRelation" (click)="addNewRelation()">
        {{ 'add_related_points' | ppTranslate }}
      </button>
    </div>
  }
</section>
